

// Layout.js

// Importing the dependencies
import { Outlet } from "react-router-dom";
import React, { useEffect } from "react";

import HeaderDesktop from '../components/navigation/HeaderDesktop';
import HeaderMobile from '../components/navigation/HeaderMobile';

// Device context — determines which header layout to mount
import { useDevice } from '../context/DeviceContext';

// Importing the style sheets
import '../styles/navigation/Layout.css';


const Layout = () => {
    const { isMobile, isTablet } = useDevice();

    useEffect(() => {
        // First we get the viewport height and we multiply it by 1% to get a value for a vh unit
        const setVh = () => {
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
    
        // We call the function at run time and on resize
        setVh();
        window.addEventListener('resize', setVh);
        return () => window.removeEventListener('resize', setVh);
    }, []);
    
    // Render the mobile header for phones and tablets; desktop header otherwise.
    // Fine-grained style adjustments within each header use @media queries in Layout.css.
    const showMobileHeader = isMobile || isTablet;

    return (
        <>
            {/* The flex box for the Header Banner and the Outlet*/}
            <div className="header-and-outlet-flex-box">

                {/* Only one header component is mounted at a time based on device type */}
                {showMobileHeader ? <HeaderMobile /> : <HeaderDesktop />}

                {/* This is the box for the outlet to the right of the tool bar and bellow the header bar */}
                <div className="outlet-flex-box">
                    {/* The Outlet for the body of the page */}
                    <Outlet context={[]}/>
                </div>

            </div>
        </>
    )
};

export default Layout;
